import CompanyAvailabilityTableRow from './CompanyAvailabilityTableRow';

export default CompanyAvailabilityTableRow;
